import logo from "../../../images/logo.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function FinishedSession({ sessionData }) {
	const [pageLoading, setPageLoading] = useState(false);

	const navigate = useNavigate();

	return (
		<section
			className="flex flex-col justify-center mt-1 mb-5 mx-smPagePadding
                    md:mx-mdPagePadding md:px-mdPagePadding
                    lg:mx-lgPagePadding lg:px-lgPagePadding
                    xl:mx-xlPagePadding xl:px-xlPagePadding
                    py-6
        "
		>
			{pageLoading && (
				<div className="fixed inset-0 bg-white/80 flex items-center justify-center z-50">
					<div className="flex flex-col items-center">
						<div className="w-10 h-10 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></div>
						<p className="mt-4 text-gray-900">Loading...</p>
					</div>
				</div>
			)}
			{/* Logo */}
			<div className="flex flex-col justify-center items-center mb-6">
				<img src={logo} alt="logo" className="w-40 h-auto object-contain" />
			</div>

			{/* Active Session */}
			<div
				className="border border-black flex flex-col justify-center items-center text-center py-5 px-2 rounded-primary bg-gray-50
            md:px-mdPagePadding 
            "
			>
				<h1 className="text-lg font-bold mb-2 py-2 md:text-l">Session ended</h1>
				<p className="px-3 py-2 mb-2 w-full ">
					We've texted your receipt to you.
				</p>
			</div>
			{/* Booth Details */}
			<div className="border-t border-b border-gray-200 py-5 flex flex-col justify-center items-center mt-7">
				<div className="flex items-center gap-3 text-textSecondary">
					<p className="text-base text-gray-600 text-center">
						Pod {sessionData?.booth?.boothId || "1"} |{" "}
						{sessionData?.booth?.location?.name ||
							"Marriott Hotel Times Square"}
					</p>
				</div>
			</div>

			{/* New Reservation Button */}
			<div
				className="flex flex-col justify-center items-center py-4 z-50 pointer-events-none mt-10
      md:px-16 md:mt-16
      lg:px-20 lg:mt-20
      "
			>
				<button
					className={`text-black w-full p-3 mb-2 rounded-secondary font-semibold transition-colors pointer-events-auto border border-gray-300 font-inter bg-white hover:text-white hover:bg-gray-700`}
					onClick={() => navigate(`/book/${sessionData.booth._id}`)}
				>
					New Reservation
				</button>
				<p className="text-textSecondary text-xs">
					Need help?{" "}
					<a href="mailto:team@pebblespaces.com">
						Contact support at <u>team@pebblespaces.com</u>
					</a>
				</p>
			</div>
		</section>
	);
}
